import { createGlobalStyle } from 'styled-components';
import { Colors } from 'constants';

export const GlobalStyles = createGlobalStyle`
	::-webkit-scrollbar {
		width: 10px;
		height: 10px;
		left: -100px;
	}
	
	::-webkit-scrollbar-track {
		background: #00C0FF;
		border-radius: 2px;
	}
	
	::-webkit-scrollbar-thumb {
		background-color: ${props => props.theme.darkBlue};
		border-radius: 2px;
		width: 10px;
	}

	* {
		scrollbar-color: ${props => props.theme.darkBlue} #00C0FF;
		scrollbar-width: thin;
	}

	svg {
		/* user-select: none !important; */
	}

	html {
		overflow-y: scroll;
		overflow-x: hidden;

		body {
			background: white;
			font-family: 'Rubik', sans-serif;
			position: relative;
			max-width: 100vw;
			width: 100%;
			height: 100vh;

			.portal .dates_input__calendar_container {
				position: fixed;
			}

			svg {
				flex-shrink: 0;
			}

			img {
				object-fit: contain;
			}

			* {
				box-sizing: border-box !important;
				font-family: 'Rubik', sans-serif;
				transition: 
					color .2s ease-in-out, 
					background-color .2s ease-in-out,
					opacity .2s ease-in-out,
					visibility .2s ease-in-out;
			}

			.react-tooltip {
				padding: 10px 15px;
				max-width: 90vw;
				transition: none !important;
				z-index: 999999999;
				box-shadow: 5px 5px 5px rgba(33, 33, 33, .3);
				border: 1px solid #333;
			}

			.react-tooltip-arrow {
				border-bottom: 1px solid #333;
				border-right: 1px solid #333;
			}

			.clickable {
				cursor: pointer;
			}

			div#root {
				min-height: 100vh;
				height: auto;
				display: flex;
				flex-direction: column;
				align-items: stretch;

				/* #header + .container, #add_info + .container {
					margin-top: 40px;
				} */

				.forClipboard {
					opacity: 0;
					width: 1px !important;
					overflow: hidden;
					display: inline-block;
				}

				.desktop {
					@media (max-width: 1279px) {
						display: none !important;
					}
				}

				.req {
					font-size: inherit;
					line-height: inherit;
					font-family: inherit;
					color: #FF6B00 !important;
					font-weight: bold !important;
				}

				.react-select-container input {
					box-shadow: none !important;
				}

				.mobile {
					@media (min-width: 1280px) {
						display: none !important;
					}
				}

				.notmobilephone {
					@media (max-width: 659px) {
						display: none !important;
					}
				}

				.mobilephone {
					@media (min-width: 660px) {
						display: none !important;
					}
				}

				.test {
					border: 1px solid red;
				}

				.filler {
					flex-grow: 1;
				}

				a {
					text-decoration: none;
					//color: ${props => props.theme.darkBlue};

					&:hover {
						color: ${props => props.theme.lightBlue};
					}

					&.active {
						color: ${props => props.theme.lightBlue};
					}
				}

				p {
					font-family: ${props => props.theme.pt};
					font-size: 16px;
					font-weight: 400;
					line-height: 21px;
					color: #333;

					&.warning {
						color: #A2001D;
						font-weight: 700;
					}

					&.orange {
						color: ${props => props.theme.orange};
					}

					b {
						font-family: inherit;
						font-size: inherit;
						line-height: inherit;
						color: inherit;
						font-weight: 700;

						&.warning {
							color: #A2001D;
							font-weight: 700;
						}

						&.blue {
							color: ${props => props.theme.darkBlue};
						}
					}

					&.center {
						text-align: center;
					}
				}

				.lineDelimiter {
					height: 1px;
					background-color: ${props => props.theme.lightGray};
					margin: 20px 0;
				}

				h1, h2, h3, h4, h5, h6 {
					color: ${props => props.theme.darkBlue};
					font-weight: 500;
					margin-bottom: 10px;

					&.orange {
						color: #FF6B00 !important;
					}

					&.margin5 {
						margin-bottom: 5px !important;
					}

					span {
						color: #00C0FF !important;
					}
				}

				h1 {
					font-size: 24px;
					line-height: 28px;
					margin-bottom: 20px;

					@media (max-width: 1279px) {
						margin-bottom: 10px;
					}

					b {
						color: #00C0FF;
					}
				}

				h2 {
					font-size: 20px;
					line-height: 24px;
				}

				h3 {
					font-size: 16px;
					line-height: 19px;
				}

				h4 {
					font-size: 14px;
					line-height: 17px;
				}

				h5 {
					font-size: 12px;
					line-height: 14px;
				}

				h6 {
					font-size: 16px;
					line-height: 19px;
				}

				.whiteLine {
					height: 0;
					width: 100%;
					border-top: 1px solid white;
				}

				.container {
					width: calc(100vw - 40px);
					
					@media (min-width: 1280px) {
						width: calc(100vw - 80px);
						max-width: 1440px;
					}

					&.margin40 {
						margin: 40px 0;
					}
				}

				.blueContainer, .lightBlueContainer {
					color: white;
					width: 100vw;
					display: flex;
					flex-direction: column;
					align-items: center;

					&.blueContainer {
						background-color: ${props => props.theme.darkBlue};
					}

					&.lightBlueContainer {
						background-color: #D3EFFF;
					}

					> div {
						width: calc(100vw - 40px);
						
						@media (min-width: 1280px) {
							width: calc(100vw - 80px);
							max-width: 1440px;
						}
					}
				}

				.button {
					cursor: pointer;
					min-height: 30px;
					font-size: 14px;
					line-height: 17px;
					display: flex;
					align-items: center;
					justify-content: center;
					text-transform: uppercase;
					border-radius: 5px;
					outline: none !important;
					padding: 0 20px;
					gap: 5px;
					user-select: none !important;

					&.noWrap {
						white-space: nowrap;
					}

					&.big {
						min-height: 40px;
					}

					&.height30 {
						font-size: 14px;
						line-height: 17px;
						min-height: 30px;
					}

					&.white {
						color: ${props => props.theme.darkBlue};
						border: 2px solid ${props => props.theme.darkBlue};
						background-color: white;

						&:hover {
							color: white;
							background-color: ${props => props.theme.darkBlue};
						}
					}

					&.blue {
						border: 2px solid ${props => props.theme.darkBlue};
						color: white;
						background-color: ${props => props.theme.darkBlue};

						&:hover {
							color: ${props => props.theme.darkBlue};
							background-color: white;
						}
					}

					&.transparent {
						border: 2px solid ${props => props.theme.darkBlue};
						color: ${props => props.theme.darkBlue};
						background-color: transparent;

						&:hover {
							color: white;
							background-color: ${props => props.theme.darkBlue};
						}
					}

					&.lightBlue {
						color: ${props => props.theme.darkBlue};
						background-color: #D3EFFF;

						&:hover {
							color: ${props => props.theme.lightBlue};
							/* background-color: white; */
						}
					}

					&.red {
						border: 2px solid #A2001D;
						background-color: #A2001D;
						color: white;
					}

					&.grad {
						background-color: ${props => props.theme.lightBlue};
						background-image: linear-gradient(180deg, #22AFFE 0%, #0270CB 100%);
						background-size: 100% calc(100% + 10px);
						background-position: 0 0;
						transition: background-position .2s ease-in-out;
						color: white;
						border: none;

						&:hover {
							background-position: 0 -10px;
						}
					}

					&.orange {
						background-color: ${props => props.theme.lightBlue};
						background-image: linear-gradient(180deg, #FEB446 0%, #FF6B00 100%);
						background-size: 100% calc(100% + 10px);
						background-position: 0 0;
						transition: background-position .2s ease-in-out;
						color: white;
						border: none;

						&:hover {
							background-position: 0 -10px;
						}
					}

					&.decline {
						border: 2px solid #A2001D;
						color: #A2001D;
						padding: 0 10px 0 5px;
						background-color: white;

						&:hover {
							background-color: #A2001D;
							color: white;
						}
					}

					&.accept {
						border: 2px solid #5BB500;
						color: #5BB500;
						padding: 0 10px 0 5px;
						background-color: white;

						&:hover {
							background-color: #5BB500;
							color: white;
						}
					}

					&.decline.disabled, &.accept.disabled {
						border: 2px solid #8D8D8D !important;
						color: #8D8D8D !important;
						cursor: not-allowed;

						&:hover {
							background-color: white !important;
							color: #8D8D8D !important;
						}
					}

					&.disabled:not(.decline):not(.accept) {
						background-color: #D1D1D1 !important;
						background-image: none !important;
						cursor: not-allowed;
						outline: none;
						border: 2px solid #D1D1D1;
					}
				}

				.marginLeft20 { margin-left: 20px; }

				.buttonAsLink {
					font-family: ${props => props.theme.pt};
					font-size: 16px;
					line-height: 21px;
					color: ${props => props.theme.darkBlue};
					transition: color .2s ease-in-out;
					display: flex;
					flex-direction: row;
					align-items: center;
					cursor: pointer;
					gap: 5px;
					/* user-select: none !important; */

					&.bold {
						font-weight: 700;
					}

					&.orange {
						color: #FF6B00 !important;

						svg {
							fill: #FF6B00 !important;

							* {
								fill: #FF6B00 !important;
							}
						}
					}

					&:not(.red) {
						svg * {
							color: ${props => props.theme.darkBlue};
							transition: color .2s ease-in-out; 
						}

						path[fill] { 
							fill: ${props => props.theme.darkBlue};
							transition: fill .2s ease-in-out; 
						}
						
						path[stroke] {
							stroke: ${props => props.theme.darkBlue};
							transition: stroke .2s ease-in-out; 
						}
						
						&:hover, &.active { 
							color: ${props => props.theme.lightBlue};
							
							> svg {
								* {
									color: ${props => props.theme.lightBlue};
								}

								path[fill] { fill: ${props => props.theme.lightBlue}; } 
								path[stroke] { stroke: ${props => props.theme.lightBlue}; }
							}
						}
					}
					
					&.red {
						color: #A2001D !important;

						svg {
							color: #A2001D !important;
							fill: #A2001D !important;

							* {
								fill: #A2001D !important;
							}
						}
					}
					
					img, svg {
						//width: 20px;
						//height: 20px;
						flex-grow: 0;
						flex-shrink: 0;
						object-fit: cover;
						object-position: center;
					}
				}

				input[type="text"]:not(.react-select__input):not(.form__input):not(.react-time-picker__inputGroup__input), input[type="password"], input:not([type]), input[type="number"]:not(.react-time-picker__inputGroup__input) {
					padding: 0 10px;
					height: 30px;
					border-radius: 2px;
					width: 100%;
					outline: none !important;
					color: ${props => props.theme.darkBlue};
					font-family: ${props => props.theme.pt};
					font-size: 16px;
					line-height: 21px;
					border: 1px solid ${props => props.theme.inputBorderColor};
					background-color: white;
					transition: box-shadow .2s ease-in-out;
					box-shadow: 0 0 0 rgba(33, 33, 33, .3);

					&.big {
						height: 40px;
					}

					&[readOnly] {
						cursor: not-allowed;
						background-color: ${props => props.theme.lightGray};
					}

					&::placeholder {
						color: ${props => props.theme.placeholderColor};
					}

					&:focus:not([readonly]) {
						box-shadow: 5px 5px 5px rgba(33, 33, 33, .3);
					}
				}

				input[type="number"]:not(.react-time-picker__inputGroup__input) {
					padding: 0 0 0 10px !important;
				}

				input.inputCheckbox {
					display: none;

					& + label {
						display: flex;
						flex-direction: row;
						align-items: center;

						&:before {
							content: '';
							display: flex;
							width: 20px;
							height: 20px;
							margin-right: 5px;
							background-repeat: no-repeat;
							background-position: center;
							background-size: cover;
							background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.5 0.5H19.5V19.5H0.5V0.5Z' fill='white' stroke='%230270CB'/%3E%3C/svg%3E%0A");
							flex: 0 0 20px;
						}
					}

					&:checked + label:before {
						background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.5 0.5H19.5V19.5H0.5V0.5Z' fill='white' stroke='%230270CB'/%3E%3Cpath d='M6.00037 9L9.00037 12L14.0004 7' stroke='%230270CB' stroke-width='2'/%3E%3C/svg%3E%0A");
					}
				}

				textarea {
					padding: 0 10px;
					width: 100%;
					outline: none !important;
					color: ${props => props.theme.darkBlue};
					font-family: ${props => props.theme.pt};
					font-size: 16px;
					line-height: 21px;
					border: 1px solid ${props => props.theme.inputBorderColor};
					border-radius: 2px;
					background-color: white;
					transition: box-shadow .2s ease-in-out;
					box-shadow: 0 0 0 rgba(33, 33, 33, .3);
					resize: none;

					&[readOnly] {
						cursor: not-allowed;
						background-color: ${props => props.theme.lightGray};
					}

					&::placeholder {
						color: ${props => props.theme.placeholderColor};
					}

					&:focus:not([readonly]) {
						box-shadow: 5px 5px 5px rgba(33, 33, 33, .3);
					}
				}
			}
          

          
          
        
            .margin-top {
                margin-top: 40px;
                @media (min-width: 980px) { margin-top: 80px; }
            }
        
            .margin-bottom {
                margin-bottom: 40px;
                @media (min-width: 980px) { margin-bottom: 80px; }
            }
        
            .padding-top {
                padding-top: 40px;
                @media (min-width: 980px) { padding-top: 80px; }
            }
        
            .padding-bottom {
                padding-bottom: 40px;
                @media (min-width: 980px) { padding-bottom: 80px; }
            }
        
            .col-1 {
                width: calc(100% - 40px);
                @media (min-width: 540px) { width: 460px; }
                @media (min-width: 660px) { width: 620px; }
                @media (min-width: 980px) { width: 940px; }
                @media (min-width: 1280px) { width: 1160px; }
                @media (min-width: 1600px) { width: 1400px; }
                flex-shrink: 0;
                flex-grow: 0;
            }
        
            .col-2 {
                width: 100%;
                @media (min-width: 540px) and (max-width: 659px) { width: 460px; }
                @media (min-width: 660px) and (max-width: 979px) { width: 620px; }
                @media (min-width: 980px) and (max-width: 1279px) { width: 460px; }
                @media (min-width: 1280px) and (max-width: 1599px) { width: 560px; }
                @media (min-width: 1600px) { width: 680px; }
            }
        
            .col-3 {
                width: 280px;
                &.square { height: 280px; }
                @media (min-width: 540px) {
                    width: 460px;
                    &.square { height: 460px; }
                }
                @media (min-width: 660px) {
                    width: 620px;
                    &.square { height: 620px; }
                }
                @media (min-width: 980px) {
                    width: 300px;
                    &.square { height: 300px; }
                }
                @media (min-width: 1280px) {
                    width: 360px;
                    &.square { height: 360px; }
                }
                @media (min-width: 1600px) {
                    width: 440px;
                    &.square { height: 440px; }
                }
            }
        
            .col-3-2 {
                flex-shrink: 0 !important;
                flex-grow: 0 !important;
                width: 280px;
                &.square { height: 280px; }
                @media (min-width: 660px) {
                    width: 460px;
                    &.square { height: 280px; }
                }
            }
        
            .col-4 {
                width: 100%;
                @media (min-width: 540px) { width: 460px; }
                @media (min-width: 660px) { width: 300px; }
                @media (min-width: 980px) { width: 220px; }
                @media (min-width: 1280px) { width: 260px; }
                @media (min-width: 1600px) { width: 320px; }
            }
        
            .text-block {
                width: calc(100% - 40px);
                @media (min-width: 540px) { width: 460px; }
                @media (min-width: 660px) { width: 620px; }
                @media (min-width: 980px) { width: 940px; }
                @media (min-width: 1280px) { width: 960px; }
                @media (min-width: 1600px) { width: 920px; }
            }
        
            .text-block-full {
                width: 100%;
                @media (min-width: 540px) { width: 460px; }
                @media (min-width: 660px) { width: 620px; }
                @media (min-width: 980px) { width: 940px; }
                @media (min-width: 1280px) { width: 960px; }
                @media (min-width: 1600px) { width: 920px; }
            }
        
            .full-320 {
                @media (max-width: 539px) { width: 100% !important; }
            }
        
            .center-text { text-align: center; }
        
            .center-margin {
                margin-left: auto;
                margin-right: auto;
            }
        
            .text-blue { color: #034781; }
            .text-white { color: white; }
            .text-bold { font-weight: 500; }
        
            .pictogram {
                width: 140px !important;
                height: 140px !important;
                object-fit: contain;
                object-position: top;
                flex-shrink: 0;
                flex-grow: 0;
                @media (min-width: 1280px) and (min-width: 1599px) {
                    width: 160px !important;
                    height: 160px !important;
                }
                @media (min-width: 1600px) {
                    width: 200px !important;
                    height: 200px !important;
                }
            }
        
            .block-fullwidth {
                width: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
            }

            .padding-5 {
              padding: 5px 0px;
            }

           .padding-10 {
              padding: 10px 20px;
            }

           .padding-20 {
               padding: 20px 20px;
            }
        
            .padding-40 {
                padding: 20px 0;
                @media (min-width: 980px) { padding: 40px 0; }
            }
        
            .padding-80 {
                padding: 40px 0;
                @media (min-width: 980px) { padding: 80px 0; }
            }
        
            .bg-blue { background-color: ${props => props.theme.darkBlue}; }
            .bg-lightblue { background-color: #D3EFFF; }
            .bg-white { background-color: ${Colors.white} !important; }
            .bg-red { background-color: #AA1F00; }
            .bg-green { background-color: #6DA544; }
        
            .color-grey {
                color: ${Colors.grey};
                * { color: ${Colors.grey}; }
            }
        
            .color-lightgrey {
                color: ${Colors.lightgrey};
                * { color: ${Colors.lightgrey}; }
            }
        
            .color-blue {
                color: ${props => props.theme.darkBlue};
                * { color: ${props => props.theme.darkBlue}; }
        
                &.hover:hover, &.active {
                    color: ${props => props.theme.lightBlue};
                    * { color: ${props => props.theme.lightBlue}; }
                }
            }
        
            .color-white {
                color: ${Colors.white};
                * { color: ${Colors.white}; }
            }
        
            .color-red {
                color: #AA1F00;
            }
        
            .orange {
                color: #FF6800;
            }
        
            .pt-sans { font-family: 'PT Sans', sans-serif !important; }
        
            .font-weight {
              font-weight: 500;    
            }
          
            .font-12 {
                font-size: 12px;
                line-height: 15px;
            }
        
            .font-14 {
                font-size: 14px;
                line-height: 17px;
            }
        
            .font-16 {
                font-size: 14px;
                line-height: 18px;
                @media (min-width: 980px) {
                    font-size: 16px;
                    line-height: 21px;
                }
            }
        
            .font-18 {
                font-size: 16px;
                line-height: 21px;
                @media (min-width: 980px) {
                    font-size: 18px;
                    line-height: 23px;
                }
            }
        
            .font-20 {
                font-size: 18px;
                line-height: 23px;
                @media (min-width: 980px) {
                    font-size: 20px;
                    line-height: 26px;
                }
            }
        
            .font-24 {
                font-size: 20px;
                line-height: 24px;
                @media (min-width: 980px) {
                    font-size: 24px;
                    line-height: 28px;
                }
            }
        
            .font-34 {
                font-size: 28px;
                line-height: 33px;
                font-weight: 500;
                @media (min-width: 980px) {
                    font-size: 34px;
                    line-height: 40px;
                }
            }
        
            .font-42 {
                font-size: 32px;
                line-height: 38px;
                font-weight: 500;
                @media (min-width: 980px) {
                    font-size: 42px;
                    line-height: 50px;
                }
            }
        
            .font-48 {
                font-size: 32px;
                line-height: 38px;
                font-weight: 500;
                @media (min-width: 980px) {
                    font-size: 48px;
                    line-height: 57px;
                }
            }
        
            .font-72 {
                font-size: 64px;
                line-height: 76px;
                font-weight: 500;
                @media (min-width: 980px) {
                    font-size: 72px;
                    line-height: 85px;
                }
            }
        
            .font-bold {
                font-weight: 500;
                &.pt-sans {
                    font-weight: 700;
                }
            }
        
            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .text-uppercase { text-transform: uppercase; }
            .test-border { border: 1px solid red; }
        
            .line {
                // width: 100%;
                height: 1px;
                margin-bottom: 20px;
                @media (min-width: 980px) { margin-bottom: 40px; }
            }
        
            .margin-bottom-10 { margin-bottom: 10px; }
            .margin-bottom-20 {
                margin-bottom: 10px;
                @media (min-width: 980px) { margin-bottom: 20px; }
            }
            .margin-bottom-40 {
                margin-bottom: 20px;
                @media (min-width: 980px) { margin-bottom: 40px; }
            }
            .margin-bottom-60 {
                margin-bottom: 20px;
                @media (min-width: 980px) { margin-bottom: 60px; }
            }
            .margin-bottom-80 {
                margin-bottom: 40px;
                @media (min-width: 980px) { margin-bottom: 80px; }
            }
        
            .flex {
                display: flex;
        
                &.column { flex-direction: column; }
                &.row { flex-direction: row; }
                &.justify-center { justify-content: center; }
                &.justify-between { justify-content: space-between; }
                &.align-center { align-items: center; }
                &.align-stretch { align-items: stretch; }
                &.align-start { align-items: flex-start; }
                &.wrap { flex-wrap: wrap; }
                &.grow { flex-grow: 1; }
                &.flip980 {
                    flex-direction: column;
                    @media (min-width: 980px) { flex-direction: row; }
                }
                &.flip660 {
                    flex-direction: column;
                    @media (min-width: 660px) { flex-direction: row; }
                }
            }
        
            .mobile-hidden {
                @media (max-width: 979px) { display: none; }
            }
        
            .button-white {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 40px;
                border: 2px solid ${props => props.theme.darkBlue};
                color: ${props => props.theme.darkBlue};
                box-sizing: border-box;
                border-radius: 5px;
                text-transform: uppercase;
                background-color: ${Colors.white};
        
                @media (min-width: 980px) {
                    height: 40px;
                }
        
                &:hover {
                    color: ${Colors.white};
                    background-color: ${props => props.theme.lightBlue};
                    border: 2px solid ${props => props.theme.lightBlue};
                }
            }
        
            .adv-list {
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                @media (min-width: 980px) {
                    flex-direction: row;
                    flex-wrap: nowrap;
                    align-items: flex-start;
                }
        
                a {
                    width: calc(100% - 40px);
                    @media (min-width: 540px) { width: 460px; }
                    @media (min-width: 660px) { width: 620px; }
                    @media (min-width: 980px) { width: 300px; }
                    @media (min-width: 1280px) { width: 360px; }
                    @media (min-width: 1600px) { width: 440px; }
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    @media (max-width: 979px) {
                        &:nth-child(n+2) { margin-top: 20px; }
                    }
        
                    p { width: 100%; }
        
                    div {
                        display: flex;
                        align-items: center;
                        justify-content: center;
        
                        img {
                            width: 85%;
                            transition: width .2s ease-in-out, height .2s ease-in-out;
                        }
                    }
        
                    &:hover {
                        p.color-blue {
                            color: ${props => props.theme.lightBlue};
                        }
        
                        div {
                            img {
                                width: 100%;
                            }
                        }
                    }
                }
            }
        
            .divider {
                height: 1px;
                background-color: ${props => props.theme.darkBlue};
            }
        
            .lightblue-container {
                background-color: #D3EFFF;
                width: 100%;
        
                div.item {
                    > img {
                        flex-grow: 0;
                        flex-shrink: 0;
                        object-fit: contain;
                        object-position: top;
                        display: flex;
                        @media (max-width: 979px) { display: none !important; }
                    }
        
                    div {
                        width: 100%;
                        @media (min-width: 540px) { width: 460px; }
                        @media (min-width: 660px) { width: 620px; }
                        @media (min-width: 980px) { width: 620px; }
                        @media (min-width: 1280px) { width: 760px; }
                        @media (min-width: 1600px) { width: 920px; }
                        @media (max-width: 539px) {
                            //padding-left: 20px;
                            //padding-right: 20px;
                        }
        
                        > img {
                            margin-bottom: 20px;
                            @media (min-width: 980px) { display: none; }
                        }
                    }
                }
            }
        
            .border {
                border: 2px solid ${props => props.theme.darkBlue};
                &.radius { border-radius: 5px; }
            }
        
            .text-underline { text-decoration: underline; }
        
            .fullwidth { width: 100%; }
        
            .width-picto {
                width: 140px;
                @media (min-width: 1280px) { width: 160px; }
                @media (min-width: 1600px) { width: 200px; }
                object-fit: cover;
            }
        
            input:focus, textarea:focus, select:focus {
                outline: none !important;
            }
        
            textarea {
                width: 100%;
                height: 250px;
                resize: none;
                border: 1px solid ${props => props.theme.darkBlue};
                color: ${props => props.theme.darkBlue};
                font-size: 16px;
                line-height: 19px;
                padding: 10px;
                margin-bottom: 20px;
            }
        
            .border-thin {
                border: 1px solid ${props => props.theme.darkBlue};
            }
        
            .small-input {
                @media (max-width: 539px) { width: 80px !important; }
            }
        
            .spaced {
                padding-left: 10px;
                padding-right: 10px;
            }
        
            .text-underline { text-decoration: underline; }
        
            .hide-980 {
                @media (max-width: 979px) { display: none !important; }
            }
        
            .show-980 {
                @media (min-width: 980px) { display: none !important; }
            }
          

		}
	}
`;

